import type { MailboxInfo } from "owa-client-types";
import { action } from "satcheljs";

export interface InitializeFeatureFlagsActionMessage {
    enabledFlights: string[];
    mailboxInfo: MailboxInfo | undefined;
    indexer: string;
}
export const featureFlagsInitialized: (enabledFlights: string[], mailboxInfo: MailboxInfo | undefined, indexer: string) => InitializeFeatureFlagsActionMessage = action("FEATURE_FLAGS_INITIALIZED", (enabledFlights: string[], mailboxInfo: MailboxInfo | undefined, indexer: string): InitializeFeatureFlagsActionMessage => ({
    enabledFlights,
    mailboxInfo,
    indexer,
}));
